module.exports = __webpack_public_path__ + "assets/img/IMG004.8049d45e.png";